import React from 'react';

export default function ChairLiftingMessage({ message }) {
  const locations = Array.isArray(message?.chairLocations) ? message.chairLocations : [];

  return (
    <div className="chair-lifting-message">
      <strong className="chair-lifting-kicker">תזכורת</strong>
      <div className="chair-lifting-title">הרמת כיסאות היום</div>
      <div className="chair-lifting-locations">
        {locations.map((location, index) => (
          <React.Fragment key={location.key || location.value}>
            {index > 0 && <span className="chair-lifting-separator"> + </span>}
            <strong
              className={`chair-lifting-location chair-lifting-location--${location.key}`}
              style={location.color ? { color: location.color } : undefined}
            >
              {location.label}
            </strong>
          </React.Fragment>
        ))}
        <span> של בית המדרש.</span>
      </div>
    </div>
  );
}
